import { Col, Row } from 'reactstrap'
import { customerCardData } from '../../../../Data/WidgetsData/GeneralData'
import CustomerCard from '../../../../Utils/CommonComponents/DashboardsCommon/DefaultCommon/CustomerCard'
import DiscountCard from '../../../../Utils/CommonComponents/DashboardsCommon/EcommerceCommon/DiscountCard'

export default function CustomerDiscountCards() {
    return (
        <Col xl={6} className="col-xl-100 box-col-12">
            <Row>
                <Col md={5}>
                    <Row>
                        <CustomerCard data={customerCardData} />
                    </Row>
                </Col>
                <Col md={7}>
                    <DiscountCard />
                </Col>
            </Row>
        </Col>
    )
}
